<script setup lang="ts"></script>

<template>
  <icon name="mdi:microsoft-word" />
</template>

<style scoped></style>
